const __WEBPACK_NAMESPACE_OBJECT__ = window["@elastic"]["apm-rum-core"];